import { SESSION_KEYS } from 'config/CustomEnums';
import { tierTypeConfig } from 'config/TierTypeConfig';
import { createModel } from 'models/BaseModel';
import {
  getGiftCardRecordList,
  getGiftCardRecord,
  parseGiftCardAction,
  parseGiftCardType,
} from 'services/GiftCardAPIHelper';
import { TimeFormater, formatDate, getDetailPageDisplayLastModifiedDate, getListDisplayLastModifiedDate } from 'utils/TimeFormatUtil';

const parseListItem = (data) => {
  const giftCard = data.giftCard;
  return {
    id: data.id,
    pk: data.pk,
    type: giftCard.type,
    displayType: parseGiftCardType(giftCard.type),
    name: giftCard.code,
    sourceName: giftCard.code,
    cashValue: `$ ${giftCard.cashValue}`,
    action: data.action,
    displayAction: parseGiftCardAction(data.action),
    expiryAt: formatDate(
      giftCard.expireAt,
      TimeFormater.dayMonthYear,
    ),
    displayCreationTime: getListDisplayLastModifiedDate(
      data.creationDate,
    ),
  };
}

const parseDetail = (data) => {
  const simpleParseData = parseListItem(data);
  const giftCard = data.giftCard;
  const recipientContact = giftCard?.sendMethod === 'email'
    ? giftCard?.recipientContact
    : giftCard?.recipientMobile;
  return {
    ...simpleParseData,
    senderContact: giftCard?.senderContact,
    shortLink: giftCard?.shortLink,
    code: giftCard?.code,
    recipientContact,
    recipientMembershipId: giftCard?.recipient?.membershipId,
    displayCreationTime: getDetailPageDisplayLastModifiedDate(
      data.creationDate,
    ),
  };
};

export default createModel({
  namespace: 'giftCardRecord',
  states: {
    listDisplayFields: [
      { displayName: 'ID', fieldName: 'pk', linked: true},
      { displayName: 'Gift card code', fieldName: 'name', linked: false },
      { displayName: 'Type', fieldName: 'displayType', hide: !tierTypeConfig.onlineStore },
      {
        displayName: 'Cash value',
        fieldName: 'cashValue',
        orderField: 'cash_value',
      },
      {
        displayName: 'Points expiry date',
        fieldName: 'expiryAt',
        orderField: 'expire_at',
      },
      {
        displayName: 'Creation time',
        fieldName: 'displayCreationTime',
        orderField: 'creation_date',
      },
      { displayName: 'Status', fieldName: 'displayAction', },
    ],
    detail: {
      sourceName: '',
      parameter: '',
    },
  },
  reducers: {},
  params: {
    sessionKey: SESSION_KEYS.GIFTCARD_RECORD_SESSION_KEY,
    dataKey: SESSION_KEYS.GIFTCARD_RECORD_DATA_SESSION_KEY,
    listAPI: getGiftCardRecordList,
    parse: (data) => data?.giftCardRecords.edges.map(
      (item) => parseListItem(item.node)
    ),
    pkNode: 'GiftCardRecordNode',
    detailAPI: getGiftCardRecord,
    parseDetail: (data) => parseDetail(data.giftCardRecord),
    objectKey: 'giftCardRecord',
  },
  effects: {
  },
});
